import PulseLoader from 'vue-spinner/src/PulseLoader';

export default {
  name: 'loader',
  components: { PulseLoader }
}